import Enums from 'utils/EnumsManager';

const { INVOICE } = Enums.REDUX_ACTION_TYPE_PREFIX;

export const SET_BI_FORM = `${INVOICE}_SET_BI_FORM`;
export const SET_BI_FIELD = `${INVOICE}_SET_BI_FIELD`;



// WEBPACK FOOTER //
// ./src/views/Invoice/flow/biForm/actionTypes.js